import { selector } from 'recoil';
import { PlanType, CnStatusCode } from '@/types/api/mypage/planInfo';
import { PlanInfoState } from '@/states/planInfoState';
import { CustomerInfoState } from '@/states/customerInfoState';

/**
 * ヘッダーやトップ画面でよく使う利用者情報をまとめた派生 state。
 * 契約者情報とプラン情報を束ね、画面側が複数 atom を毎回参照しなくて済む形に整える。
 */
export type UserStateType = {
  name: string;
  ispCnNo: string;
  planName: string;
  cnStatusCode: CnStatusCode | undefined;
  planType: PlanType | undefined;
  isNuro: boolean;
  isHighend: boolean;
  isMansion: boolean;
  isOpen: boolean;
};

/** 契約者情報とプラン情報から画面表示用の利用者サマリーを組み立てる selector。 */
const userState = selector<UserStateType>({
  key: 'userState',
  get: ({ get }) => {
    const planInfo = get(PlanInfoState);
    const customerInfo = get(CustomerInfoState);
    return {
      // 表示頻度の高い名前・契約番号・サービス種別判定をここでまとめて返す。
      name: `${customerInfo.last_name} ${customerInfo.first_name}`,
      ispCnNo: customerInfo.contract_no,
      planName: planInfo.planName,
      cnStatusCode: planInfo.cnStatusCode,
      planType: planInfo.planType,
      isNuro: planInfo.serviceType === 'nuro',
      isHighend: planInfo.serviceType === 'highend',
      isMansion: planInfo.serviceType === 'mansion',
      isOpen: planInfo.serviceStartDate != null,
    };
  },
});

export { userState };
